// Rabattcodes (Beta): Filterwert der Buchungsliste für „ohne Rabattcode“. Codes bestehen nur aus Großbuchstaben, Ziffern
// und Bindestrichen (DISCOUNT_CODE_PATTERN), der Wert mit Leerzeichen kann also mit keinem Code zusammenfallen. Er ist
// zugleich lesbar, weil die Leiste „Aktive Filter“ den Filterwert unverändert anzeigt. Client schreibt, Server liest.
export const DISCOUNT_CODE_FILTER_NONE = "ohne Rabattcode";
